import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  Box, Card, CardHeader, Grid, IconButton, LinearProgress, ListItemIcon, Menu, MenuItem, Alert, AlertTitle,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV, faEdit, faMapMarked } from '@fortawesome/free-solid-svg-icons';
import md from '../../../const/meta';
import { ErrorMessage } from '../../../components/Styled/Misc';
import usePayerItems from './hooks';

function PayerLands({ payerId }) {
  const {
    items, loading, err, selectedId, setSelectedId,
  } = usePayerItems({ payerId, subUrl: 'get_lands' });

  return (
    <>
      <Grid container spacing={2}>
        {loading && (
          <Grid item sm={12}>
            <Box sx={{ width: '100%' }}>
              <LinearProgress />
            </Box>
          </Grid>
        )}
        {err && (
          <Grid item sm={12}>
            <ErrorMessage text={err} />
          </Grid>
        )}
        {!items.length && !loading && (
          <Grid item xs={12}>
            <Alert severity="info" variant="outlined">
              <AlertTitle>Важлива інформація</AlertTitle>
              Зімельні ділянки відсутні
            </Alert>
          </Grid>
        )}
        {items.map(((item) => (
          <Grid item sm={3} key={item.id}>
            <Card>
              <CardHeader
                avatar={<FontAwesomeIcon icon={faMapMarked} size="2x" />}
                title={item.repr}
                subheader={`${item.area} га, ${item.address}`}
                action={(
                  <IconButton
                    aria-label="menu"
                    id={`menu-button-${item.id}`}
                    onClick={() => setSelectedId(item.id)}
                  >
                    <FontAwesomeIcon icon={faEllipsisV} />
                  </IconButton>
                )}
              />
            </Card>
          </Grid>
        )))}
      </Grid>
      <Menu
        anchorEl={() => document.getElementById(`menu-button-${selectedId}`)}
        open={!!selectedId}
        onClose={() => setSelectedId(null)}
      >
        <MenuItem onClick={() => null}>
          <Link to={`${md.cat.lands.frontend}${selectedId}`}>
            <ListItemIcon>
              <FontAwesomeIcon icon={faEdit} />
            </ListItemIcon>
            Детальніше
          </Link>
        </MenuItem>
      </Menu>
    </>
  );
}

PayerLands.propTypes = {
  payerId: PropTypes.number.isRequired,
};
export default PayerLands;
